module.exports = __webpack_public_path__ + "img/pic_explain02@2x.28b7f82a.png";